/**
 * Centralized Supabase URL/key resolution for direct fetch() calls to edge functions.
 * Falls back to hardcoded project URL/anon key when build-time env injection is missing
 * (external preview & published builds). RLS enforces actual security.
 */
const FALLBACK_URL = "https://huxeknkddlrffeterchr.supabase.co";
const FALLBACK_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1eGVrbmtkZGxyZmZldGVyY2hyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE4MzMwMzQsImV4cCI6MjA3NzQwOTAzNH0.u74YfE_IRRexzL6Xgof-dnUppi0pkKELSpe1Wc64JOw";

export const SUPABASE_URL: string =
  (import.meta.env.VITE_SUPABASE_URL as string | undefined) || FALLBACK_URL;

export const SUPABASE_PUBLISHABLE_KEY: string =
  (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined) || FALLBACK_KEY;

export function functionUrl(name: string): string {
  return `${SUPABASE_URL}/functions/v1/${name}`;
}